"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var display_logic_1 = require("@shared/types/display-logic");
var environment_1 = require("@shared/types/environment");
var ranked_display_logic_1 = require("@shared/types/ranked-display-logic");
var type_narrowing_1 = require("@shared/utils/type-narrowing");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prConditionalDisplay', [
        '$http',
        '$q',
        'pr.API_ROUTES',
        'prFilterUtils',
        'pr.globalOptionsService',
        'prResponseCount',
        'prFields',
        'prDisplayLogicService',
        'pr.filters',
        'rsEnvironment',
        'prRankedDisplayLogic',
        function (
        // @ts-ignore
        $http, 
        // @ts-ignore
        $q, 
        // @ts-ignore
        API_ROUTES, 
        // @ts-ignore
        filterUtils, 
        // @ts-ignore
        globalOptions, responseCount, 
        // @ts-ignore
        fieldService, 
        // @ts-ignore
        displayLogicService, 
        // @ts-ignore
        prFilters, 
        // @ts-ignore
        env, 
        // @ts-ignore
        rankedDisplayLogic) {
            var widgetDisplayConfigs = {};
            var USE_ENV_DISPLAY_LOGIC = 'env';
            var DISPLAY_CONFIG_ENABLED_DEFAULT = {
                enabled: true,
                hideInPublic: false
            };
            /**
             * check if the display logic of a widget is enabled
             */
            function isDisplayLogicEnabled(widgetId) {
                var displayConfig = widgetDisplayConfigs[widgetId];
                return displayConfig && displayConfig.enabled;
            }
            /**
             * check if a widget should be hidden in the public report
             */
            function isHiddenInPublic(widgetId) {
                var displayConfig = widgetDisplayConfigs[widgetId];
                // @ts-ignore
                return isDisplayLogicEnabled(widgetId)
                    && displayConfig.hideInPublic;
            }
            /**
             * compute display logic based on response threshold or custom rules
             * if meets condition - display the widget in public report
             * else - hide the widget in public report
             *
             * @param {WidgetId} widgetId
             * @param {DataConfig} dataConfig - widget.state.sharedData.dataConfig
             */
            function computeWidgetConditionalDisplay(widgetId, dataConfig) {
                // NOTE: this will fail if/when we support display logic for a widget with multiple sources
                var sourceId = dataConfig.sourceId || lodash_1.default.get(dataConfig, 'metrics.0.sourceId', '');
                var displayLogic = dataConfig.displayLogic;
                var displayLogicCopy = lodash_1.default.cloneDeep(displayLogic);
                // if using default, get global options values
                if (lodash_1.default.isUndefined(displayLogicCopy) || displayLogicCopy === USE_ENV_DISPLAY_LOGIC) {
                    displayLogicCopy = globalOptions.getDisplayLogic();
                }
                var isAdvanced = displayLogicService.isValidID(displayLogicCopy);
                // if display logic is disabled
                var displayLogicEnabled;
                // @ts-ignore
                if (type_narrowing_1.hasProperty(displayLogicCopy, 'enabled')) {
                    displayLogicEnabled = displayLogicCopy.enabled;
                }
                if (!isAdvanced && displayLogicCopy && !displayLogicEnabled) {
                    var displayConfig = {
                        enabled: false
                    };
                    setWidgetDisplayConfig(widgetId, displayConfig);
                    return $q.resolve();
                }
                if (!dataConfig.type) {
                    return $q.resolve();
                }
                var displayLogicResponseThreshold;
                // @ts-ignore
                if (type_narrowing_1.hasProperty(displayLogicCopy, 'responseThreshold')) {
                    displayLogicResponseThreshold = displayLogicCopy.responseThreshold;
                }
                var responseThreshold = (displayLogicCopy && displayLogicResponseThreshold) || 0;
                if (!isAdvanced) {
                    return computeBasicDisplayLogic(widgetId, dataConfig, responseThreshold);
                }
                // pr-records-component
                if (dataConfig.type === "pr-records-component" /* RECORDS */) {
                    var fieldIds = dataConfig && dataConfig.fields;
                    return computeAdvancedDisplayLogic(widgetId, fieldIds, dataConfig);
                }
                // other types of data components
                var fieldId = getFieldId(dataConfig);
                // all choices/groups field
                if (fieldService.isGroupMetric(fieldId)) {
                    var allChoices = fieldService.getAllChoicesById(sourceId, fieldId);
                    var fieldIds = lodash_1.default.map(allChoices, 'fieldId');
                    return computeAdvancedDisplayLogic(widgetId, fieldIds, dataConfig);
                }
                // single field
                return computeAdvancedDisplayLogic(widgetId, [fieldId], dataConfig);
            }
            /**
             * Checks if rankable items is used in the display logic.
             * Returns a boolean array indicating whether question and/or scoring categories are used.
             *
             * @param {DataConfig} dataConfig - widget.state.sharedData.dataConfig
             */
            function checkRankableDisplayLogic(dataConfig) {
                var _a;
                var displayLogicId = dataConfig.displayLogic;
                var displayLogicDef = displayLogicService.getDisplayLogic(displayLogicId);
                var displayLogicChildren = (_a = displayLogicDef === null || displayLogicDef === void 0 ? void 0 : displayLogicDef.children) !== null && _a !== void 0 ? _a : [];
                var allDisplayLogic = flattenDisplayLogic(displayLogicChildren);
                var fieldRankable = false;
                var scoringCategoriesRankable = false;
                lodash_1.default.forEach(allDisplayLogic, function (child) {
                    // @ts-ignore
                    if (type_narrowing_1.hasProperty(child, 'displayLogic') && type_narrowing_1.hasProperty(child.displayLogic, 'category')) {
                        if (child.displayLogic.category === ranked_display_logic_1.RANKABLE_ITEMS && type_narrowing_1.hasProperty(child.displayLogic, 'rankableValue')) {
                            var rankableValue = child.displayLogic.rankableValue;
                            if (rankableValue === "Scoring Category" /* SCORING_CATEGORY */) {
                                scoringCategoriesRankable = true;
                            }
                            else if (rankableValue === "Question" /* QUESTION */) {
                                fieldRankable = true;
                            }
                        }
                    }
                });
                return [fieldRankable, scoringCategoriesRankable];
            }
            function flattenDisplayLogic(
            // @ts-ignore
            displayLogicChildren, allDisplayLogic) {
                if (allDisplayLogic === void 0) { allDisplayLogic = []; }
                lodash_1.default.forEach(displayLogicChildren, function (displayLogic) {
                    if (displayLogic.type === "displayLogic" /* DISPLAY_LOGIC */) {
                        allDisplayLogic.push(displayLogic);
                    }
                    if (displayLogic.children && displayLogic.children.length) {
                        return flattenDisplayLogic(displayLogic.children, allDisplayLogic);
                    }
                });
                return allDisplayLogic;
            }
            /**
             * get fieldId based on type of data component
             */
            function getFieldId(dataConfig) {
                if (!dataConfig) {
                    return '';
                }
                var fieldId = type_narrowing_1.hasProperty(dataConfig, 'fieldId') ? dataConfig.fieldId : '';
                switch (dataConfig.type) {
                    case "pr-metric-component" /* METRIC */:
                    case "pr-geometry-component" /* GEOMETRY */:
                        var metric = dataConfig.metrics && dataConfig.metrics[0];
                        return metric && metric.fieldId;
                    case "pr-stats-component" /* STATS */:
                        return fieldId;
                    case "pr-wordcount-component" /* WORDCOUNT */:
                        return dataConfig.fields && dataConfig.fields[0];
                    default:
                        return fieldId || '';
                }
            }
            function computeBasicDisplayLogic(widgetId, dataConfig, responseThreshold) {
                var displayConfig = lodash_1.default.cloneDeep(DISPLAY_CONFIG_ENABLED_DEFAULT);
                // wrap in $q.resolve() so sync errors are caught
                return $q.resolve().then(function () {
                    return responseCount.getWidgetResponseCount(widgetId, dataConfig, {
                        returnRequestOptions: true
                    });
                    // @ts-ignore
                }).catch(function (error) {
                    if (error.unsupportedWidget) {
                        // If the widget does not support response count calculations
                        // Then it also does not support display logic
                        throw error;
                    }
                    console.error('Could not get widget response count for display logic', error);
                    // Treat response count as 0 so we don't unexpectedly
                    // show widgets that should support display logic
                    return {
                        count: 0
                    };
                    // @ts-ignore
                }).then(function (response) {
                    if (response.count < responseThreshold) {
                        displayConfig.hideInPublic = true;
                    }
                    setWidgetDisplayConfig(widgetId, displayConfig);
                    delete response.count;
                    return __assign(__assign({}, response), { type: display_logic_1.DisplayLogicType.BASIC });
                    // @ts-ignore
                }).catch(function (error) {
                    console.error('Could not set display logic for widget', widgetId, dataConfig);
                });
            }
            /**
             * For advanced display logic,
             * update widget display config when there are multiple fields
             */
            function computeAdvancedDisplayLogic(widgetId, fieldIds, dataConfig) {
                if (!lodash_1.default.isArray(fieldIds)) {
                    return $q.resolve();
                }
                var displayConfig = lodash_1.default.cloneDeep(DISPLAY_CONFIG_ENABLED_DEFAULT);
                var promises = lodash_1.default.map(fieldIds, function (fieldId) {
                    return computeDisplayLogic(fieldId, dataConfig);
                });
                // @ts-ignore
                return $q.all(promises).then(function (responseArray) {
                    // when there are multiple fields in a single widget,
                    // display the widget if there's a true for any field
                    var someMeetCondition = lodash_1.default.some(responseArray, 'meetsCondition');
                    displayConfig.hideInPublic = !someMeetCondition;
                    setWidgetDisplayConfig(widgetId, displayConfig);
                    var requestOptionsArray = lodash_1.default.map(responseArray, 'requestOptions');
                    return {
                        requestOptionsArray: requestOptionsArray,
                        type: display_logic_1.DisplayLogicType.ADVANCED
                    };
                });
            }
            function setOptions(dataConfig, fieldId) {
                var widgetFilters = dataConfig.filters || {};
                // NOTE: this will fail if/when we support display logic for a widget with multiple sources
                var sourceId = dataConfig.sourceId || lodash_1.default.get(dataConfig, 'metrics.0.sourceId', '');
                var requestFilters = prepRequestFilters(widgetFilters, sourceId, fieldId);
                // In advanced mode, displayLogic id is stored in dataConfig
                var displayLogicId = dataConfig.displayLogic;
                var displayLogicDef = displayLogicService.getDisplayLogic(displayLogicId);
                var displayLogicDataConfig = lodash_1.default.assign(lodash_1.default.cloneDeep(dataConfig), {
                    displayLogic: displayLogicDef
                });
                if (displayLogicService.shouldHave360DisplayLogic()) {
                    var relationships = env.get(environment_1.ENV_VARS.RELATIONSHIPS_BETWEEN_PERSONS);
                    if (relationships) {
                        displayLogicDataConfig.relationshipsBetweenPersons = relationships;
                    }
                }
                var _a = checkRankableDisplayLogic(dataConfig), calculateFields = _a[0], calculateScoringCategories = _a[1];
                return $q.resolve().then(function () {
                    if (calculateFields || calculateScoringCategories) {
                        return rankedDisplayLogic.computeRankedDisplayLogic(dataConfig, sourceId, calculateFields, calculateScoringCategories
                        // @ts-ignore
                        ).then(function (averages) {
                            return {
                                displayLogicDataConfig: displayLogicDataConfig,
                                requestFilters: requestFilters,
                                averages: averages
                            };
                        });
                    }
                    return {
                        displayLogicDataConfig: displayLogicDataConfig,
                        requestFilters: requestFilters
                    };
                });
            }
            /**
             * compute display logic and check if it meets the condition
             */
            function computeDisplayLogic(fieldId, dataConfig) {
                // @ts-ignore
                return setOptions(dataConfig, fieldId).then(function (options) {
                    return $http.post(API_ROUTES.DISPLAY_LOGIC, options, { cache: true })
                        // @ts-ignore
                        .then(function (response) {
                        return response.data;
                    }).catch(function () {
                        return false;
                        // @ts-ignore
                    }).then(function (meetsCondition) {
                        return {
                            meetsCondition: meetsCondition,
                            requestOptions: options
                        };
                    });
                });
            }
            /**
             * prepare filters for sending aggregate request
             */
            function prepRequestFilters(widgetFilters, sourceId, fieldId) {
                var overrideFilters = prFilters.getOverrideFilters();
                overrideFilters = (overrideFilters || {})[sourceId] || {};
                var overrideFiltersCopy = lodash_1.default.cloneDeep(overrideFilters);
                widgetFilters = (widgetFilters || {})[sourceId] || {};
                var widgetFiltersCopy = lodash_1.default.cloneDeep(widgetFilters);
                filterUtils.fixDateFilters(overrideFiltersCopy);
                filterUtils.fixDateFilters(widgetFiltersCopy);
                var presentFieldFilter = getPresentFieldFilter(fieldId);
                return {
                    type: 'and',
                    children: [widgetFiltersCopy, overrideFiltersCopy, presentFieldFilter]
                };
            }
            /**
             * create a filter that only includes survey responses that responded to the field.
             */
            function getPresentFieldFilter(fieldId) {
                return {
                    type: 'filter',
                    filter: {
                        field: fieldId || '_recordId',
                        operator: 'present',
                        operand: true
                    },
                    children: []
                };
            }
            function setWidgetDisplayConfig(widgetId, config) {
                widgetDisplayConfigs[widgetId] = config;
            }
            return {
                isDisplayLogicEnabled: isDisplayLogicEnabled,
                isHiddenInPublic: isHiddenInPublic,
                computeWidgetConditionalDisplay: computeWidgetConditionalDisplay,
                checkRankableDisplayLogic: checkRankableDisplayLogic
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
